export function lowerTimeBound(timestamp, inclusive = false) {
    return {
        type: "lower",
        lowerBound: { timestamp, inclusive },
    };
}
export function upperTimeBound(timestamp, inclusive = false) {
    return {
        type: "upper",
        upperBound: { timestamp, inclusive },
    };
}
/**
 * TODO: Support inclusive on both upper and lower?
 */
export function intervalTimeBound(lowerTS, upperTS, inclusive = false) {
    return {
        type: "interval",
        upperBound: { timestamp: upperTS, inclusive },
        lowerBound: { timestamp: lowerTS, inclusive },
    };
}
export class ActionRecordRepository {
}
//# sourceMappingURL=ActionRecordRepository.js.map